// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"403":"c18e04ed","507":"446a65d3","520":"10d4cd78","737":"e60dd634","963":"461b8380"}[chunkId] + ".chunk.css";
};